// Query keys for dashboard feature
export const dashboardKeys = {
  all: ["dashboards"] as const,
  lists: () => [...dashboardKeys.all, "list"] as const,
  list: () => [...dashboardKeys.lists()] as const,
  details: () => [...dashboardKeys.all, "detail"] as const,
  detail: (slug: string) => [...dashboardKeys.details(), slug] as const,
  default: () => [...dashboardKeys.all, "default"] as const,
};

// Query keys for widget feature
export const widgetKeys = {
  all: ["widgets"] as const,
  lists: () => [...widgetKeys.all, "list"] as const,
  list: (dashboardId: string) => [...widgetKeys.lists(), dashboardId] as const,
  details: () => [...widgetKeys.all, "detail"] as const,
  detail: (widgetId: string) => [...widgetKeys.details(), widgetId] as const,
  queries: () => [...widgetKeys.all, "query"] as const,
  query: (widgetId: string, params: Record<string, unknown>) =>
    [...widgetKeys.queries(), widgetId, params] as const,
};

